import Cart from "../entities/cart";

/**
 * @interface
 */
export default class LaserhubsRepository {    
    fetchCartWithStockItems(items, address, stockId, allLaserhubs) {}
}
